import React from "react";

const screenshots = [
  { id: 1, src: "screenshot1.jpg", alt: "Login Screen" },
  { id: 2, src: "screenshot2.jpg", alt: "Dashboard" },
  { id: 3, src: "screenshot3.jpg", alt: "Recharge Screen" },
  { id: 4, src: "screenshot4.jpg", alt: "Reports" },
  { id: 5, src: "screenshot5.jpg", alt: "Reports" },
  { id: 5, src: "screenshot6.jpg", alt: "Reports" },
  { id: 5, src: "screenshot7.jpg", alt: "Reports" },
  { id: 5, src: "screenshot8.jpg", alt: "Reports" },
];

const Screenshots = () => {
  return (
    <section id="screenshots" className="py-5">
      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="section-title">App Screenshots</h2>
          <p className="lead">See how Formax Pay App looks and works</p>
        </div>

        <div className="row">
          {screenshots.map((screenshot) => (
            <div className="col-md-3 col-6 mb-4" key={screenshot.id}>
              <img
                src={`/assets/images/${screenshot.src}`}
                alt={screenshot.alt}
                className="img-fluid app-screenshot"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Screenshots;
